<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex"
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Order Dispatch Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      total_amount: 0,
      total_paid: 0,
      filterSales: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        user: '',
        category: '',
        branch_id: 0
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Order Dispatch Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Order Dispatch Report",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "customer",
          sortable: true,
          label: 'CUSTOMER',
        },
        {
          key: "product",
          sortable: true,
          label: 'PRODUCT',
        },
        {
          key: "qty",
          sortable: true,
          label: 'QTY',
        },
        {
          key: "qty_remaining",
          sortable: true,
          label: 'QTY REMAINING',
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user",
          sortable: true,
          label: "ADDED BY",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
        {
          key: "addedon",
          sortable: true,
          label: "RECORDED ON",
        },
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch",
          sortable: true,
          label: 'BRANCH',
        },
        {
          key: "customer",
          sortable: true,
          label: 'CUSTOMER',
        },
        {
          key: "product",
          sortable: true,
          label: 'PRODUCT',
        },
        {
          key: "qty",
          sortable: true,
          label: 'QTY',
        },
        {
          key: "qty_remaining",
          sortable: true,
          label: 'QTY REMAINING',
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user",
          sortable: true,
          label: "ADDED BY",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
        {
          key: "addedon",
          sortable: true,
          label: "RECORDED ON",
        },
      ],

      json_fields: {
        CUSTOMER: "customer",
        PRODUCT_NAME: "product",
        QUANTITY: "qty",
        QUANTITY_REMANINING: "qty_remaining",
        UNITS: "usymbol",
        DATE: "date",
        ADDED_BY: "user",
        RECEIPT: "receipt",
        RECORDED_ON: "addedon",
      },

      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("sales", ["filterStatus", "DispatchReport"]),
    ...mapGetters("auth", ["business", "branch", "Branches", "branchid"]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.DispatchReport ? this.DispatchReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.DispatchReport ? this.DispatchReport.length : 1;
  },
  methods: {
    ...mapActions({
      FetchDispatchReport: "sales/fetchDispatchReport",
      FetchProducts: "products/fetchProducts",
      FetchCustomers: "customers/fetchCustomers",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",

    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    OrderDispatchData() {
      this.FetchDispatchReport(this.filterSales);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  updated() {
    let total_amount = 0;
    // let total_paid = 0;
    if (this.DispatchReport) {
      this.DispatchReport.forEach((item) => {
        total_amount = total_amount + parseInt(item.total_priceno);
      });
      this.total_amount = total_amount;
    }
  },
  watch: {
    DispatchReport(newValue) {
      if (newValue == true) {
        this.OrderDispatchData();
      }
    }
  },
  created() {
    this.FetchDispatchReport(this.filterSales);
    this.FetchProducts();
    this.OrderDispatchData();
    this.FetchCustomers();
    this.FetchGeneralSettings();
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center">Order dispatch report from {{ filterSales.datefrom }} to
                  {{ filterSales.dateto }}</h3>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-md-8">
                <download-excel class="btn btn-primary" :data="DispatchReport" :fields="json_fields"
                  :worksheet="'ORDER DISPATCH REPORT AS OF' + currentdate" type="csv"
                  :name="'orderdispatch_report' + currentdate + '.xls'">
                  Export Excel <i class="fa fa-file-excel"></i>
                </download-excel>
              </div>
              <div class="col-md-4 mb-2" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>

                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="filterSales.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="OrderDispatchData()">
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input type="date" v-model="filterSales.datefrom" class="form-control" />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input v-model="filterSales.dateto" type="date" class="form-control" />
              </div>
              <div class="col-md-3 form-group">
                <label>Products</label>

                <model-list-select :list="Products ? Products : []" v-model="filterSales.product" option-value="id"
                  option-text="name" placeholder="Select Product" @input="OrderDispatchData()">
                </model-list-select>
              </div>
              <div class="col-md-3 form-group">
                <label>Customers</label>

                <model-list-select :list="Customers ? Customers : []" v-model="filterSales.customer" option-value="id"
                  option-text="name" placeholder="Select Customer" @input="OrderDispatchData()">
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="OrderDispatchData()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="filterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="DispatchReport ? DispatchReport : []" :fields="branchid == 0 ? fields1 : fields"
                responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc"
                :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(qty)="data">
                  {{ data.item.qty }} {{ data.item.usymbol }}
                </template>
                <template #cell(qty_remaining)="data">
                  {{ data.item.qty_remaining }} {{ data.item.usymbol }}
                </template>
              </b-table>
              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <h5>Total Amount: <span class="text-danger">{{ thousandSeperator(total_amount) }}</span></h5>
                </div>
              </div>
            </div>
            <Loader v-if="!DispatchReport" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>